const path = require('path');

module.exports = {
    id: 'core',
    name: 'core',
    salt: '',
    defaultSCSSPath: path.resolve(__dirname, `../../widgets/themes/core/core.default.scss`),
    themesDir: path.resolve(__dirname, `../../widgets/themes/core/`)
};



/** WEBPACK FOOTER **
 ** ../src/config/clients/core.spec.js
 **/